import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MONTHS_S } from '@/constants';
import { catById } from '@/utils';
import Amt from '@/common/components/amt';
import { useClickDouble } from '@/hooks/useClickDouble';
import style from './style.module.scss';
function CalCell({ date, transactions, balance, currency, budget, isToday, isSelected, muted, onSelect, onAddTx, }) {
    const handler = useClickDouble(onSelect, onAddTx);
    const typeOrder = { income: 0, savings: 1, expense: 2 };
    const all = [
        ...transactions.filter((tx) => tx.planned != null),
        ...transactions.filter((tx) => tx.actual != null && tx.planned == null),
    ].sort((a, b) => (typeOrder[a.type] ?? 9) - (typeOrder[b.type] ?? 9));
    return (_jsxs("div", { className: [
            style['cal-cell'],
            isToday ? style['today'] : '',
            isSelected ? style['selected'] : '',
            muted ? style['muted'] : '',
        ]
            .filter(Boolean)
            .join(' '), onClick: muted ? onSelect : handler, children: [_jsxs("div", { className: style['cal-date'], children: [_jsx("span", { className: style['cal-date-num'], children: date.getDate() }), date.getDate() === 1 && (_jsx("span", { className: style['cal-date-mon'], children: MONTHS_S[date.getMonth()] }))] }), balance !== undefined && (_jsx("div", { className: [style['cal-balance'], balance < 0 ? style['neg'] : ''].filter(Boolean).join(' '), children: _jsx(Amt, { value: balance, currency: currency }) })), _jsxs("div", { className: style['cal-chips'], children: [all.slice(0, 4).map((tx) => {
                        const cat = tx.category ? catById(budget, tx.category) : null;
                        const label = cat
                            ? `${cat.icon} ${tx.description || cat.label}`
                            : tx.description ||
                                (tx.type === 'income' ? 'Доход' : tx.type === 'savings' ? 'Накопление' : 'Расход');
                        return (_jsxs("div", { className: [
                                style['cal-chip'],
                                style[tx.fromSavings ? 'income' : tx.type],
                                tx.actual != null ? style['confirmed'] : '',
                            ]
                                .filter(Boolean)
                                .join(' '), children: [tx.seriesId && _jsxs("svg", { style: { width: 8, height: 8, marginRight: 2, verticalAlign: 'middle', flexShrink: 0 }, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("path", { d: "M17 1l4 4-4 4" }), _jsx("path", { d: "M3 11V9a4 4 0 0 1 4-4h14" }), _jsx("path", { d: "M7 23l-4-4 4-4" }), _jsx("path", { d: "M21 13v2a4 4 0 0 1-4 4H3" })] }), label] }, tx.id));
                    }), all.length > 4 && _jsxs("div", { className: style['cal-chip-more'], children: ["+", all.length - 4] })] })] }));
}
export default CalCell;
